const $mainMenuItem = $('.js-catalog-desktop-item');
const $subMenu = $('.js-sub-catalog');
const $subMenuItem = $('.js-sub-catalog-item');
const $lastMenu = $('.js-last-sub-catalog');

$subMenuItem.hover(function () {
    if ($(this).find($lastMenu).outerHeight() < $(this).closest($subMenu).outerHeight()) {
        $(this).find('.js-last-sub-catalog').outerHeight($(this).closest($subMenu).outerHeight());
    } 
});
